import React from 'react';
const AcbSettings = React.lazy(() => import('pages/AcbPayment/AcbSettings'));
const routes = [{ path: '/acb-payment', exact: true, name: 'Kết nối ACB theo cửa hàng', function: 'ACB_PAYMENT_CONFIG', component: AcbSettings }];
export default routes;
